import React, { useState } from 'react';
import { RxCross1 } from 'react-icons/rx';
import { useParams } from 'react-router-dom';

const ShareListing = ({ setShareListing }) => {
    const [formData, setFormData] = useState({
        email: '',
    });
    const [showCopyPopup, setShowCopyPopup] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleCopy = () => {
        setShowCopyPopup(true);
        navigator.clipboard.writeText(window.location.href)
        setTimeout(() => setShowCopyPopup(false), 2000); // Hide the popup after 2 seconds
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    };

    return (
        <div className='flex z-30 justify-center lg:pt-[10%] w-full fixed lg:absolute bottom-0 lg:bottom-auto'>
            <form onSubmit={handleSubmit} className='flex flex-col px-10 py-10 bg-white rounded-sm gap-5 w-full lg:w-auto'>
                <div id='header' className='flex justify-between items-center'>
                    <span className="font-semibold text-xl">Email this Home</span>
                    <div onClick={() => setShareListing(false)} className='flex justify-end cursor-pointer'>
                        <RxCross1 className='text-gray font-bold' size={18} />
                    </div>
                </div>
                <div className='flex flex-col gap-1'>
                    <span className='font-medium text-sm'>Recipient's Email</span>
                    <div className='flex border-2 rounded-sm py-2.5 px-4'>
                        <input
                            className='w-full sm:text-auto text-sm outline-none'
                            placeholder='Enter email'
                            type="email"
                            name="email"
                            id="email"
                            onChange={handleChange}
                        />
                    </div>
                    <span className='font-light text-xs text-[#8C969F]'>Separate multiple addresses with a comma</span>
                </div>
                <div className='flex items-center justify-between lg:gap-16'>
                    <button
                        type="button"
                        className='text-sm py-2 rounded-lg flex justify-center items-center bg-[#0062FF] text-white px-5 transition-transform duration-300 hover:scale-105'
                    >
                        <a href={`mailto:${formData.email}?subject=I think you'll like this property!&body=Hey there!%0D%0A%0D%0AI thought you would like this house.%0D%0A%0D%0ATake a look and let me know what you think!%0D%0A%0D%0A${window.location.href}`} target="_blank">Send Email</a>
                    </button>
                    <div className="copy-button-container">
                        <button
                        className="text-[#0062FF] font-semibold cursor-pointer text-sm hover:underline"
                        type="button"
                        onClick={handleCopy}
                        >
                            <span className="flex gap-1 items-center">Get shareable link</span>
                        </button>
                        {showCopyPopup && <div className="copy-popup-share-listing">Copied!</div>}
                    </div>
                </div>
            </form>
        </div>
    );
};

export default ShareListing;
